// Description: This Stimulus controller manages the state of a submit button based on checkbox selection.
// If at least one checkbox is checked, the submit button is enabled; otherwise, it remains disabled.
// Additionally, it controls the visibility of a Bootstrap tooltip to indicate why the button is disabled.
//
// Targets:
// - checkbox: Represents the checkboxes that need to be checked for submission.
// - submit: Represents the submit button that gets enabled/disabled based on selection.
//
// Behavior:
// - When no checkboxes are checked, the submit button is disabled, and the tooltip is shown.
// - When at least one checkbox is checked, the submit button is enabled, and the tooltip is hidden.
//
// Example usage:
// <form data-controller="enable-submit">
//   <input type="checkbox" data-enable-submit-target="checkbox" data-action="enable-submit#toggleSubmitButton">
//   <button data-enable-submit-target="submit" data-toggle="tooltip" title="Please select at least one checkbox to enable submit." disabled>
//     Submit
//   </button>
// </form>

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'submit']

  connect() {
    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    const isChecked = this.checkboxTargets.some((checkbox) => checkbox.checked);
    const submit = this.submitTarget;

    submit.disabled = !isChecked;
    $(submit).tooltip(submit.disabled ? 'enable' : 'disable');
  }
}
